import Toaster from '@cobliteam/colib-ui/Toaster';
import { useSyncExternalStore } from 'react';

const subscribeToHtmlClass = (onChange: () => void) => {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  return () => observer.disconnect();
};

const getHtmlTheme = () => (document.documentElement.classList.contains('dark') ? 'dark' : 'light');

// A classe `.dark` do <html> é a fonte do tema (o ThemeButton só a liga para coblers); sem
// ThemeProvider do next-themes, o Toaster da colib cairia em 'system' e seguiria o SO.
const AppToaster = () => {
  const theme = useSyncExternalStore(subscribeToHtmlClass, getHtmlTheme);

  return <Toaster theme={theme} richColors closeButton position='top-right' />;
};

export default AppToaster;
